interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  linkHref?: string;
  linkLabel?: string;
}

function SectionHeading({
  eyebrow,
  title,
  desc,
  linkHref,
  linkLabel,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 md:mb-10 flex flex-wrap items-end justify-between gap-4">
      <div>
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
          <i className="ri-sparkling-2-fill" aria-hidden="true"></i>
          {eyebrow}
        </span>
        <h2 className="font-heading mt-3 text-2xl md:text-4xl text-foreground-900">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 max-w-xl text-sm md:text-base text-foreground-600">
            {desc}
          </p>
        )}
      </div>
      {linkHref && linkLabel && (
        <a
          href={linkHref}
          className="inline-flex items-center gap-1 text-sm whitespace-nowrap text-primary-700 hover:text-primary-800"
        >
          {linkLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </a>
      )}
    </div>
  );
}

export default SectionHeading;